// Purpose: massive padlock watermark on the right side of the sign-in
// hero. Stroke-only; color + opacity driven by CSS vars so theme flip
// re-colors without React state. The mockup uses 620×620 at
// right:-40, top:50% translate-y:-50%.
//
// Sizing + color/opacity tokens live on the `.padlock-watermark`
// class in styles.css so the rendered DOM carries no `style="..."`
// attribute (Commit 8b.8 dropped style-src `'unsafe-inline'`). The
// `size` + `style` props that previously customized this per-instance
// were unused by callers (Login, ExternalShell both call <PadlockWatermark />
// with no overrides) and were removed with the inline-style refactor.

export interface PadlockWatermarkProps {
  className?: string;
}

export function PadlockWatermark({ className }: PadlockWatermarkProps) {
  return (
    <div
      aria-hidden
      className={[
        'absolute pointer-events-none',
        'top-1/2 -translate-y-1/2',
        'padlock-watermark',
        className ?? '',
      ].join(' ')}
    >
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        fill="none"
        stroke="currentColor"
      >
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" strokeWidth="0.6" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" strokeWidth="0.6" />
      </svg>
    </div>
  );
}
